
<div class="main-container popup" (click)="$event.stopPropagation()">
    <div>
        <ng-content></ng-content>
    </div>
</div>